import * as auth from '@api/auth';
import * as schedule from '@api/schedule';
import * as deviceInfo from '@api/deviceInfo';
import * as deviceSetting from '@api/deviceSetting';
import * as myPage from '@api/myPage';
import * as playList from '@api/playlist';
import * as video from '@api/video';

export default {
  auth,
  schedule,
  deviceInfo,
  deviceSetting,
  myPage,
  playList,
  video,
};
